const BrokerageTradingInstructionContent = {
  title: "Buy shares of stocks, ETFs and other securities",
  subtitle: "Start diversifying your portfolio with a range of investments. You can browse various securities and place trade orders any time on a convenient trading platform. All trades will be executed during market hours.",
  steps: [
    {
      content: "Add the ticker symbol or CUSIP number of the investment you’d like to buy"
    },
    {
      content: "Decide how much you want to invest"
    },
    {
      content: "Select from a variety of brokerage order types"
    }
  ],
  notes: []
};

export default BrokerageTradingInstructionContent;
